import { Outlet } from "react-router-dom";
import { DashboardShell } from "@/components/layout/dashboard-shell";

export function DashboardLayout() {
	return (
		<DashboardShell>
			<Outlet />
		</DashboardShell>
	);
}
